// iter87.262 (operator-corrected) — seed<=6 (MLB) / seed<=10 (NBA) is
// a LIVE snapshot, not a locked-in fact. Division races and wild card
// spots can flip on the last day of the regular season, so a team
// sitting at seed 7 today could still get in tomorrow (and vice
// versa). `missed_playoffs` on a team doc always reflects live seed —
// this helper is what tells the UI whether that snapshot is still
// provisional or actually final, so copy doesn't overclaim certainty.
//
// Signal: real playoff SERIES only get added into a round once actual
// playoff games appear in the vendor schedule — the round shells
// themselves (`rounds[].key/label/series: []`) are pre-built as soon
// as the tournament exists, so checking `rounds.length` alone is not
// enough. Must check that some round actually has series entries.
export function isPlayoffFieldFinal(tournament) {
    const rounds = [
        ...(tournament?.mlb?.rounds || []),
        ...(tournament?.nba?.rounds || []),
        ...(tournament?.nfl?.rounds || []),
    ];
    return rounds.some(r => (r.series || r.games || []).length > 0);
}

// Shared copy for a team that's currently outside the qualifying cutoff.
export function missedPlayoffsCopy(teamName, tournament, { locked = false, subject = "Your pick" } = {}) {
    const fieldFinal = isPlayoffFieldFinal(tournament);
    if (!fieldFinal) {
        return `${teamName} is currently outside the projected field (seeding isn't final — this can still change before the last day of the regular season).`;
    }
    return locked
        ? `${teamName} missed the playoffs — ${subject.toLowerCase()} won't score.`
        : `${teamName} missed the playoffs — pick a replacement.`;
}
